import { G_GRAPH__BUTTON__image_asset_select_from_existing } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_buttons/G_GRAPH__BUTTON__image_asset_select_from_existing';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_BUTTON__image_asset_select_from_existing({ field }: PROPS) {
  /*
   * STORE
   */

  /*
   * EVENTS
   */

  /*
   * HTML
   */

  return <G_GRAPH__BUTTON__image_asset_select_from_existing size="full-6" variant={'outline-on-component'} text="Select from existing" {...{ field }} />;
}
